import Layout from '../components/Layout';
import Seo from '../components/Seo';

export default function Personvern() {
  return (
    <Layout>
      <Seo title="Personvernerklæring – Specialists.no" description="Personvernerklæring for Specialists.no i tråd med GDPR." canonical="https://specialists.no/personvern" />
      <section className="bg-[#0A1F44] text-white py-14">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-display text-4xl font-bold">Personvernerklæring</h1>
          <p className="text-white/60 mt-2 text-sm">Sist oppdatert: Januar 2025</p>
        </div>
      </section>
      <section className="py-14">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-5 text-[#334155]">
          <h2 className="font-display text-xl font-bold text-[#0A1F44] mt-4">1. Behandlingsansvarlig</h2>
          <p>Specialists.no er behandlingsansvarlig for personopplysninger samlet inn via denne nettsiden. Kontakt: kontakt@specialists.no.</p>

          <h2 className="font-display text-xl font-bold text-[#0A1F44] mt-4">2. Hvilke opplysninger samler vi inn?</h2>
          <p>Ved utfylling av skjemaet samler vi inn navn, telefonnummer, e-postadresse, by, ønsket behandling og eventuelt en melding fra deg. Vi samler også inn anonymiserte bruksdata (sesjon-ID, sidevisninger) for å forbedre tjenesten.</p>

          <h2 className="font-display text-xl font-bold text-[#0A1F44] mt-4">3. Formål</h2>
          <p>Opplysningene brukes utelukkende for å videreformidle din forespørsel til klinikken du selv har valgt, og for å sende deg en bekreftelse.</p>

          <h2 className="font-display text-xl font-bold text-[#0A1F44] mt-4">4. Hvem får opplysningene?</h2>
          <p>Kun klinikken du har valgt mottar dine kontaktopplysninger. Vi deler ikke data med tredjeparter utover dette. Vi benytter tekniske underleverandører (Supabase for datalagring og Resend for e-post) som er forpliktet til strenge databehandleravtaler.</p>

          <h2 className="font-display text-xl font-bold text-[#0A1F44] mt-4">5. Lagringstid</h2>
          <p>Vi oppbevarer dine opplysninger i inntil 12 måneder, deretter slettes de automatisk. Du kan når som helst be om sletting før dette.</p>

          <h2 className="font-display text-xl font-bold text-[#0A1F44] mt-4">6. Dine rettigheter</h2>
          <p>Du har rett til innsyn, retting, sletting og dataportabilitet. Du kan også trekke tilbake samtykke når som helst. Henvendelser rettes til kontakt@specialists.no.</p>

          <h2 className="font-display text-xl font-bold text-[#0A1F44] mt-4">7. Sikkerhet</h2>
          <p>Data overføres kryptert (HTTPS) og lagres på sikre servere i EØS-området. Tilgang er begrenset til autorisert personell.</p>

          <h2 className="font-display text-xl font-bold text-[#0A1F44] mt-4">8. Klageadgang</h2>
          <p>Mener du vi behandler dine opplysninger i strid med regelverket? Du kan klage til Datatilsynet (datatilsynet.no).</p>
        </div>
      </section>
    </Layout>
  );
}
